// Global Setup - Make npm packages available globally
import { createClient } from '@supabase/supabase-js';
import emailjs from '@emailjs/browser';

// Setup Supabase globally
if (typeof window !== 'undefined') {
  // Get environment variables for Supabase
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (supabaseUrl && supabaseAnonKey) {
    const supabase = createClient(supabaseUrl, supabaseAnonKey);

    // Make available globally as legacy code expects
    window.supabase = supabase;

    // Also setup the supabase object as the CDN version did
    window.supabase.createClient = createClient;
  }

  // Setup EmailJS globally
  window.emailjs = emailjs;

  console.log('✅ Global libraries setup complete (Supabase, EmailJS)');
}

export { createClient, emailjs };